import React from 'react';
import './DashboradContentBar.scss';
import { StatsTabs } from './ContentBarTabs/ContentBarTabs';
import { FavsTabs } from './ContentBarTabs/ContentBarTabs';

const DashboradContentBar = ({ activeIndex }) => (
  <div className="dashboradContentBar">
    {activeIndex === 0 && <StatsTabs />}
    {activeIndex === 1 && <FavsTabs />}
  </div>
);

export default DashboradContentBar;
